import { render, staticRenderFns } from "./ApiAccess.vue?vue&type=template&id=b51cfdae"
import script from "./ApiAccess.vue?vue&type=script&lang=js"
export * from "./ApiAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports